const globalCalls = {
};

export default globalCalls;